import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Constante } from '../../constante';
import { ResponseApi, PagedResultApi } from '../models/response-api';
import { RolApi, UsuarioApi } from '../models/api/usuario-api';
import { TransaccionApi } from '../models/api/pedido-api';
import { AppUtil } from '../utility/app-util';

@Injectable({ providedIn: 'root' })
export class UsuarioService {
    private http = inject(HttpClient);
    private url = AppUtil.addTrailingSlash(environment.URL_API_PEDIDOS) + 'api/usuario/';

    listUsuarios(key = '', pageNumber = 1, pageSize = 9): Observable<PagedResultApi<UsuarioApi>> {
        let params = new HttpParams().set('pageNumber', pageNumber).set('pageSize', pageSize);
        if (key.trim()) {
            params = params.set('key', key.trim());
        }
        return this.http.get<ResponseApi<PagedResultApi<UsuarioApi>>>(this.url + 'list-usuarios', { params }).pipe(
            map((res) => {
                if (res.success !== Constante.REQUEST_STATUS_OK || !res.data) {
                    throw new Error(this.readError(res));
                }
                return res.data;
            })
        );
    }

    listRoles(): Observable<RolApi[]> {
        return this.http.get<ResponseApi<RolApi[]>>(this.url + 'list-roles').pipe(
            map((res) => (res.success === Constante.REQUEST_STATUS_OK && Array.isArray(res.data) ? res.data : []))
        );
    }

    assignRol(usuarioUuid: string, rolUuid: string): Observable<TransaccionApi> {
        return this.http.post<ResponseApi<TransaccionApi>>(this.url + 'assign-rol/' + usuarioUuid, { rolUuid }).pipe(
            map((res) => this.requireData(res))
        );
    }

    removeRol(usuarioUuid: string, rolUuid: string): Observable<TransaccionApi> {
        return this.http.delete<ResponseApi<TransaccionApi>>(this.url + 'remove-rol/' + usuarioUuid + '/' + rolUuid).pipe(
            map((res) => this.requireData(res))
        );
    }

    toggleActivo(usuarioUuid: string): Observable<TransaccionApi> {
        return this.http.put<ResponseApi<TransaccionApi>>(this.url + 'toggle-activo/' + usuarioUuid, {}).pipe(
            map((res) => this.requireData(res))
        );
    }

    private requireData(res: ResponseApi<TransaccionApi>): TransaccionApi {
        if (res.success !== Constante.REQUEST_STATUS_OK || !res.data) {
            throw new Error(this.readError(res));
        }
        return res.data;
    }

    private readError(res: ResponseApi<unknown>): string {
        const errors = res.errors as { message?: string }[] | null;
        return errors?.[0]?.message || res.message || 'Ocurrió un error inesperado.';
    }
}
